import React from 'react';

interface StepCardProps {
  children: React.ReactNode;
  className?: string;
}

export const StepCard = ({ children, className = '' }: StepCardProps) => {
  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-6 w-full max-w-full h-[430px] ${className}`}>
      {children}
    </div>
  );
};